import { memo } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { Icon } from "@iconify/react";
import saveFill from "@iconify/icons-eva/save-fill";
import PropTypes from "prop-types";
import { BRAND } from "src/theme/brandTokens";

const TopBarFormularioV2 = ({
  titulo,
  onGuardarBorrador,
  guardando,
  disabled,
}) => (
  <Box
    sx={{
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: { xs: 2, sm: 4 },
      py: 1.5,
      borderBottom: `1px solid ${BRAND.color.divider}`,
      bgcolor: BRAND.color.paper,
    }}
  >
    <Typography
      variant="subtitle1"
      sx={{ fontFamily: BRAND.font.family.base, fontWeight: 600 }}
    >
      {titulo}
    </Typography>
    <Button
      variant="outlined"
      size="small"
      startIcon={<Icon icon={saveFill} width={16} />}
      onClick={onGuardarBorrador}
      disabled={disabled || guardando}
      sx={{
        textTransform: "none",
        fontFamily: BRAND.font.family.base,
      }}
    >
      {guardando ? "Guardando..." : "Guardar borrador"}
    </Button>
  </Box>
);

TopBarFormularioV2.propTypes = {
  titulo: PropTypes.string.isRequired,
  onGuardarBorrador: PropTypes.func.isRequired,
  guardando: PropTypes.bool,
  disabled: PropTypes.bool,
};

TopBarFormularioV2.defaultProps = {
  guardando: false,
  disabled: false,
};

export default memo(TopBarFormularioV2);
